<template>
  <div class="custom-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Wrapper'
}
</script>

<style lang="scss" scoped>
.custom-wrapper {
  width: 96%;
  margin: 1.6rem auto;
  box-sizing: border-box;
  padding: 1rem;
  background: #FFFFFF;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Wrapper.vue